import '../../../stylesheets/dashboards/dashboards.css'
import '../../../stylesheets/dashboards/leaderboard.css'
import '../../../stylesheets/dashboards/leaderboard-heat-tiers.css'
import { useState, useEffect, useRef }                                          from 'react'
import { usePublicAPI }                                                         from '../../../hooks/external/proprietary/usePublicAPI.js';
import { resolveStackedClassForColor, resolveStackedClassForColorShading,
        resolveChangeSignage,                                               }   from '../../../services/leaderboard/main/main.js';
import { formatNumber, formatNumberTwoDecimal,
         formatPercent, formatDollar }                                          from '../../../utilities/formatNumber.js';

const MoversGridLayout = (props) => {

    const {orderedCompanyPriceData, cpdActiveFields, period, type} = props

    // **====== Hooks ======** //
    const { getCoLogo } = usePublicAPI();

    return (
        <div className="leaderboard-grid-container">
            {orderedCompanyPriceData.map((cpd) => (
                <div
                    key={cpd.id}
                        className={`leaderboard-cell ${resolveStackedClassForColor(cpd[cpdActiveFields.heat], "all-cos")} ${resolveStackedClassForColorShading(cpd[cpdActiveFields.shading], "all-cos")}`}
                >
                    <img
                        src={getCoLogo(cpd.ticker)}
                        alt={cpd.name}
                        className="logo-card-company-logo leaderboard"
                    />
                    <div className="leaderboard-cell-ticker">{cpd.ticker}</div>                                        
                    <div className="leaderboard-cell-change">
                        {/* symbol for change value displayed based on heat (+/-) and type ($/%) */}
                        {resolveChangeSignage(cpd[cpdActiveFields.change], cpd[cpdActiveFields.heat], type)}
                    </div>
                    <div className="leaderboard-tooltip">
                        <span className="leaderboard-cell-ticker"> {cpd.ticker}</span>
                        <span className="leaderboard-cell-name">{cpd.name}</span>
                        <span className="leaderboard-cell-price">${formatNumberTwoDecimal(cpd.priceCurrent)}</span>                        
                    </div>
                </div>
            ))}
        </div>        
    )
}


export default MoversGridLayout;